import React from 'react';
import { Flex, Box, Text } from 'components/ui';
import StarRating from 'components/StarRating/StarRating';
import ReviewCount from 'components/Product/ReviewCount/ReviewCount';
import stringUtils from 'utils/String';
import { getText } from 'components/ProductPage/ProductCompareTool/ProductCompareToolItem/compareItemLocale';
import { styles } from 'components/ProductPage/ProductCompareTool/ProductCompareToolItem/compareItemStyles';

const { capitalize } = stringUtils;

export const renderRatingCell = ({ sku, index }) => {
    const hasSentiments = sku?.sentiments && Array.isArray(sku.sentiments) && sku.sentiments.length > 0;
    const hasReviews = sku?.productReviewCount > 0;

    const formattedSentiments = hasSentiments ? sku.sentiments.map(s => `${capitalize(s.sentiment)} (${s.count})`).join(', ') : '';

    return (
        <Box
            key={`rating-${index}`}
            backgroundColor={index === 0 && 'nearWhite'}
            borderLeftWidth={index > 0 && 1}
            borderColor={index > 0 && 'divider'}
            borderTopWidth={1}
            borderTopColor='divider'
            paddingLeft={4}
            paddingRight={4}
        >
            <div
                css={{
                    ...styles.cell,
                    ...(!hasReviews && {
                        justifyContent: 'center',
                        alignItems: 'center',
                        height: '100%'
                    })
                }}
            >
                {sku && (
                    <>
                        {!hasReviews && <Text aria-label='No reviews'>-</Text>}
                        {hasReviews && !hasSentiments && (
                            <Flex
                                alignItems='center'
                                lineHeight='none'
                            >
                                {sku.starRatings ? (
                                    <Text
                                        children={sku.starRatings?.toFixed(1)}
                                        css={styles.reviewRating}
                                    />
                                ) : null}
                                <StarRating
                                    size={12}
                                    rating={sku.starRatings}
                                />
                                <ReviewCount
                                    css={styles.reviewCount}
                                    productReviewCount={sku.productReviewCount}
                                    showParentheses
                                />
                            </Flex>
                        )}
                        {hasReviews && hasSentiments && (
                            <>
                                <Flex
                                    alignItems='center'
                                    lineHeight='none'
                                    marginBottom={2}
                                >
                                    {sku.starRatings ? (
                                        <Text
                                            children={sku.starRatings?.toFixed(1)}
                                            css={styles.reviewRating}
                                        />
                                    ) : null}
                                    <StarRating
                                        size={12}
                                        rating={sku.starRatings}
                                    />
                                    <ReviewCount
                                        css={styles.reviewCount}
                                        productReviewCount={sku.productReviewCount}
                                        showParentheses
                                    />
                                </Flex>
                                <Box>
                                    <Text>
                                        <span css={styles.highlyRatedLabel}>{getText('highlyRated', [])}:</span> {formattedSentiments}
                                    </Text>
                                </Box>
                            </>
                        )}
                    </>
                )}
            </div>
        </Box>
    );
};
